/**
 * Hover menu behavior for desktop navigation
 * Opens dropdown on hover, closes on mouse leave
 * Shimmer plays on open then loops at random 2.5–5s intervals
 */
document.addEventListener('DOMContentLoaded', function() {
  var hoverMenus = document.querySelectorAll('.bwl-hover-menu');

  /* ── Shimmer helpers ── */
  function triggerShimmer(el) {
    el.classList.remove('shimmer-playing');
    void el.offsetWidth;
    el.classList.add('shimmer-playing');
  }

  function startShimmerLoop(el) {
    if (!el) return;
    triggerShimmer(el);

    function scheduleNext() {
      var delay = 2500 + Math.random() * 2500;
      el._shimmerTimer = setTimeout(function() {
        triggerShimmer(el);
        scheduleNext();
      }, delay);
    }
    scheduleNext();
  }

  function stopShimmerLoop(el) {
    if (!el) return;
    clearTimeout(el._shimmerTimer);
    el.classList.remove('shimmer-playing');
  }

  /* ── Desktop hover menus ── */
  function closeAllMenus() {
    hoverMenus.forEach(function(m) {
      m.removeAttribute('open');
    });
  }

  hoverMenus.forEach(function(menu) {
    menu.addEventListener('mouseenter', function() {
      closeAllMenus();
      menu.setAttribute('open', '');
      startShimmerLoop(menu.querySelector('.bwl-dropdown__featured-row'));
    });

    menu.addEventListener('mouseleave', function() {
      menu.removeAttribute('open');
      stopShimmerLoop(menu.querySelector('.bwl-dropdown__featured-row'));
    });

    var summary = menu.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function(e) {
        var link = summary.querySelector('.bwl-menu-link');
        if (link && (e.target === link || link.contains(e.target))) {
          e.stopPropagation();
          return;
        }
        e.preventDefault();
      });
    }
  });

  /* ── Mobile drawer shimmer ── */
  var drawer = document.getElementById('Details-menu-drawer-container');
  if (drawer) {
    drawer.addEventListener('toggle', function() {
      var featured = drawer.querySelector('.menu-drawer__item--featured');
      if (drawer.open) {
        startShimmerLoop(featured);
      } else {
        stopShimmerLoop(featured);
      }
    });
  }
});
